export default {
  translate(locale, textId = '', textEn = '') {
    textEn = textEn == null ? '' : textEn;
    if (locale === 'en' && textEn.trim() !== '') {
      return textEn;
    } else if (locale === 'id') {
      return textId;
    }
    return textId;
  },
  getWebVersion() {
    const el = document.querySelector('[data-web-version]');
    if (el) {
      return el.dataset.webVersion;
    }
    return 'web version not found';
  }
}